<template>
  <div class="page">
    <div class="title">輸入諸掛（無償）請求書</div>
    <div class="top">
      <div class="topLeft">
        <div>{{ shipment.name }}</div>
        <div>{{ shipment.displayBuName }}</div>
        <div>{{ shipment.displayWarehouseName }}</div>
      </div>
      <div class="topRight">
        <div>発行日：{{ today }}</div>
        <div>
          請求番号：{{ shipment.invoiceSeqNo
          }}{{
            shipment.issuePrintedCount > 0
              ? '-R' + shipment.issuePrintedCount
              : ''
          }}
        </div>
        <div style="font-size: 10px !important">
          請求書番号を必ず入力ください
        </div>
      </div>
    </div>

    <div class="middle">
      <div class="introductionLeft">
        <div>毎々格別のお引き立てを賜り厚く御礼申し上げます。</div>
        <div>
          下記の通り、業務委託費用のご請求を申し上げますので、ご照合の上、お支払い願います。
        </div>
        <div>振込手数料は御社にて負担願います。</div>
        <div>
          尚、万一内容にご不審な点がございましたら、お手数ですが、弊社経理担当までご確認ください。
        </div>
      </div>
      <div class="introductionRight">
        <div>〒590-8522</div>
        <div>大阪府堺市堺区匠町1番地</div>
        <div>シャープジャスダロジスティクス株式会社</div>
        <div>輸入部</div>
        <div>TEL:050-5433-4139 or (4142)</div>
        <div>FAX:072-282-1580</div>
        <div>登録番号:{{shipment.registrationNumber}} </div>
        <div style="font-size: 8px !important; margin-top: 110px">
          (財務経理チーム 072(282)1550)
        </div>
      </div>
    </div>

    <div
      class="mark"
      v-if="shipment.confirmed && operation !== 'CONFIRM'"
    ></div>

    <div class="signature">
      発行者
      <div class="signatureLine"></div>
    </div>

    <div class="amount">
      <div class="space">
        <!-- |currency({fractionCount:0}) -->
        <div class="totalAmountTitle">ご請求金額</div>
        <div class="totalAmount">
          {{ jpySubTotal | currency({ fractionCount: 0 }) }}円
        </div>
      </div>
      <div class="boldLine"></div>
    </div>

    <div class="bottom">
      <div class="bottomLeft">
        <div>お振込の場合は下記宛お願い致します。</div>
        <div>口座名義 シャープジャスダロジスティクス株式会社</div>
        <div>
          取引銀行 みずほ銀行 大阪法人支店【0001-080】（当座・口座No.5444071）
        </div>
      </div>
      <div class="bottomRight">
        <div>取引先コード＝19910</div>
        <div>支払条件：月末締翌末日払い【定時払い】</div>
        <div>（経理ポータル→支払依頼で処理ください）</div>
      </div>
    </div>

    <div class="shipmentInfo">
      <div class="basicInfo">INVOICE No:{{ shipment.invoiceNos }}</div>
      <div class="basicInfo">B/L No:{{ shipment.blNo }}</div>
      <div class="basicInfo">D/O No:{{ shipment.doNo }}</div>
    </div>

    <div class="datatable">
      <table>
        <tr>
          <td class="centerText">月 日</td>
          <td class="centerText">売伝番号注文</td>
          <td class="centerText">品名</td>
          <td class="centerText">数量</td>
          <td class="centerText">単価（税抜）</td>
          <td class="centerText" style="width: 100px">金額（税抜）</td>
          <td class="centerText">税区分</td>
          <td class="centerText">備考</td>
        </tr>
        <tr :key="charge.id" v-for="charge in eiajCharges">
          <td>{{ shipment.forecastDeliveryDate }}</td>
          <td>{{ shipment.doNo }}</td>
          <td>{{ charge.chargeItemName }}</td>
          <td>{{ charge.qty }}</td>
          <td>{{ charge.unitPrice }}</td>
          <td class="amountFormat">
            {{ charge.subTotal | currency({ fractionCount: 0 }) }}
          </td>
          <td>{{ charge.consumptionTaxRate === 0 ? '免税' : '課税' }}</td>
          <td>{{ charge.comment }}</td>
        </tr>
        <tr :key="charge.id" v-for="charge in eiajAdditionalCharges">
          <td>{{ shipment.forecastDeliveryDate }}</td>
          <td>{{ shipment.doNo }}</td>
          <td>{{ charge.comment || charge.chargeItemName }}</td>
          <td>{{ charge.qty }}</td>
          <td>{{ charge.unitPrice }}</td>
          <td class="amountFormat">
            {{ charge.subTotal | currency({ fractionCount: 0 }) }}
          </td>
          <td>{{ charge.consumptionTaxRate === 0 ? '免税' : '課税' }}</td>
          <td>{{ charge.comment }}</td>
        </tr>
        <tr>
          <td colspan="5">課税対象以外 小計</td>
          <td class="amountFormat">
            {{
              (eiajUntaxedFee + eiajAdditionalUntaxedFee)
                | currency({ fractionCount: 0 })
            }}
          </td>
          <td rowspan="2"></td>
        </tr>
        <tr>
          <td colspan="5">課税対象 小計</td>
          <td class="amountFormat">
            {{
              (eiajTaxedFee + eiajAdditionalTaxedFee)
                | currency({ fractionCount: 0 })
            }}
          </td>
        </tr>
        <tr>
          <td class="blank"></td>
          <td class="blank"></td>
          <td class="blank"></td>
          <td class="blankRight"></td>
          <td style="border: 1px solid black; z-index: 20">消費税{{ eiajTaxedConsumptionTaxRates }}</td>
          <td class="amountFormat">
            {{ eiajTax | currency({ fractionCount: 0 }) }}
          </td>
          <td class="blank"></td>
        </tr>
        <tr>
          <td class="blank"></td>
          <td class="blank"></td>
          <td class="blank"></td>
          <td class="blankRight"></td>
          <td>合 計</td>
          <td class="amountFormat">
            {{ jpySubTotal | currency({ fractionCount: 0 }) }}
          </td>
          <td class="blank"></td>
        </tr>
      </table>
    </div>

    <div class="footer">
      <div class="summary">
        <div>(税抜)</div>
        <div>
          免 税 計
          <span class="amountNum">{{
            (eiajUntaxedFee + eiajAdditionalUntaxedFee)
              | currency({ fractionCount: 0 })
          }}</span>
        </div>
        <div>
          課税対象外計
          <span class="amountNum"></span>
        </div>
        <div>
          課 税 計
          <span class="amountNum">{{
            (eiajTaxedFee + eiajAdditionalTaxedFee)
              | currency({ fractionCount: 0 })
          }}</span>
        </div>
      </div>
      <div>
        <span class="amountNum">{{
          (eiajUntaxedFee + eiajTaxedFee + eiajAdditionalFee)
            | currency({ fractionCount: 0 })
        }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['shipment', 'operation'],
  computed: {
    today() {
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      return year + '年' + month + '月' + day + '日'
    },
    jpySubTotal() {
      return (
        this.eiajUntaxedFee +
        this.eiajTaxedFee +
        this.eiajTax +
        this.eiajAdditionalFee
      )
    },
    jpyCharges() {
      return this.shipment.charges
        .filter((c) => c.currencyCode === 'JPY')
        .filter((c) => c.chargeItemScopes !== '1')
        .filter((c) => c.chargeItemScopes !== '4')
    },
    eiajCharges() {
      return this.shipment.eiajChargeVos
        .filter((c) => c.currencyCode === 'JPY')
        .filter((c) => c.scopes !== '1')
        .filter((c) => c.scopes !== '4')
        .filter((c) => c.chargeItemCode !== 'SEA-011')
        .filter((c) => c.chargeItemCode !== 'AIR-008')
        .filter((c) => c.chargeItemCode !== 'LOCAL-010')
        .filter((c) => c.chargeItemCode !== 'SEA-013')
        .filter((c) => c.chargeItemCode !== 'AIR-010')
    },
    eiajAdditionalCharges() {
      if (this.shipment.chargeDetails.length > 0) {
        return this.shipment.chargeDetails.sort(function(a, b) {
          return Number(a.seq) - Number(b.seq)
        })
      }
      return this.eiajAdditionalChargesByEiaj;
    },
    eiajAdditionalChargesByEiaj(){
      return this.shipment.eiajChargeVos
        .filter((c) => c.scopes === '1' || c.scopes === '4')
        .filter((c) => c.jpySubTotal !== 0)
        .sort(function(a, b) {
          return Number(a.seq) - Number(b.seq)
        })
    },
    eiajTaxedCharges() {
      return this.eiajCharges.filter((c) => c.consumptionTaxRate > 0)
    },
    eiajUntaxedCharges() {
      return this.eiajCharges.filter(
        (c) => c.consumptionTaxRate === 0 || c.consumptionTaxRate === null
      )
    },
    eiajTaxedConsumptionTaxRates() {
      const fees =  this.eiajCharges.filter(
        (c) => c.consumptionTaxRate >0
      ).map(i=>i.consumptionTaxRate)
      // const fees=[0.100,0.0800]
      const formattedArray = [...new Set(fees)].map((value) => `${(value * 100).toFixed(0)}%`);
      const formattedString = formattedArray.join('/');
      return '('+formattedString+')'

    },
    eiajTaxedFee() {
      return this.eiajTaxedCharges.reduce((t, c) => {
        return (t = t + c.subTotal)
      }, 0)
    },
    eiajUntaxedFee() {
      return this.eiajUntaxedCharges.reduce((t, c) => {
        return (t = t + c.subTotal)
      }, 0)
    },
    eiajTax() {
      return this.shipment.eiajs.filter(i=>i.purchaseOrderId==null).reduce((t,c)=>{return t+c.jpyTax},0);
      // return Math.round(
      //   (this.eiajTaxedFee + this.eiajAdditionalTaxedFee) *
      //     this.consumptionTaxRate
      // )
    },
    eiajAdditionalTaxedFee() {
      return this.eiajAdditionalCharges
        .filter((c) => c.consumptionTaxRate !== 0)
        .reduce((t, c) => {
          return (t = t + c.subTotal)
        }, 0)
    },
    eiajAdditionalUntaxedFee() {
      return this.eiajAdditionalCharges
        .filter(
          (c) => c.consumptionTaxRate === 0 || c.consumptionTaxRate === null
        )
        .reduce((t, c) => {
          return (t = t + c.subTotal)
        }, 0)
    },
    eiajAdditionalFee() {
      return this.eiajAdditionalCharges.reduce((t, c) => {
        return (t = t + c.subTotal)
      }, 0)
    },
    consumptionTaxRate() {
      var rates = this.eiajTaxedCharges.sort(function(a, b) {
        return a.consumptionTaxRate > b.consumptionTaxRate
      })
      var consumptionTaxRate = 0
      if (rates.length > 0) {
        consumptionTaxRate = rates[0].consumptionTaxRate
      }
      return consumptionTaxRate
    },
    jpyTax() {
      return this.shipment.charges.filter((c) => c.currencyCode === 'JPY')
    },
  },
}
</script>
<style scoped>
.title {
  display: block;
  text-align: center;
  font-size: 25px !important;
}

.top {
  display: block;
}

.topLeft {
  font-size: 15px;
  display: inline-block;
}

.topRight {
  font-size: 15px;
  display: inline-block;
  float: right;
}

.introductionLeft {
  margin-top: 100px;
  font-size: 15px;
  width: 50%;
  display: inline-block;
  border: 1px dashed grey;
}

.introductionRight {
  font-size: 12px;
  width: 30%;
  display: inline-block;
  float: right;
}

.middle {
}

.mark {
  /* border: 1px solid red; */
  width: 200px;
  height: 200px;
  background-image: url('../../assets/img/stamp1.png');
  position: absolute;
  right: 100px;
  top: 150px;
  opacity: 0.8;
}
.signature {
  border: 1px solid black;
  width: 75px;
  height: 100px;
  top: 250px;
  right: 40px;
  border-radius: 15px;
  position: absolute;
  text-align: center;
  padding-top: 10px;
}

.signatureLine {
  border-bottom: 1px solid black;
  width: 75px;
  height: 10px;
}

.amount {
  margin-top: 20px;
  width: 40%;
}

.space {
  display: flex;
  justify-content: space-between;
}

.totalAmountTitle {
  font-size: 30px;
}

.totalAmount {
  font-size: 30px;
}

.boldLine {
  display: block;
  width: 100%;
  border: 2px solid black;
}

.bottom {
  margin-left: 20px;
  display: flex;
  justify-content: space-between;
}

.bottomLeft {
  margin-top: 30px;
  font-size: 10px;
  display: inline-block;
}

.bottomRight {
  font-size: 18px;
  display: inline-block;
  float: right;
}

table {
  margin: 40px 0 0 0;
  width: 100%;
  border: 1px solid white;
  border-collapse: collapse;
}

table td {
  border: 1px solid black;
  font-size: 18px !important;
}

.out {
  height: 0;
  border: 1px solid black;
  width: 100px;
  transform: rotate(190deg);
}

.blank {
  border: 1px solid white;
}

.blankBottom {
  border-bottom: 1px solid white;
}

.blankRight {
  border-top: 1px solid white;
  border-left: 1px solid white;
  border-bottom: 1px solid white;
}

.centerText {
  text-align: center;
}

.amountFormat {
  padding-right: 5px;
  text-align: right;
}

.datatable {
  margin-top: -70px;
  width: 100%;
}

.footer {
  width: 30%;
  display: block;
  font-size: 18px;
}

.amountNum {
  float: right;
}
.page {
  padding: 30px 30px;
  font-size: 12px;
}

.shipmentInfo {
  display: flex;
  padding: 20px 0;
}
.basicInfo {
  font-size: 20px;
  margin: 20px;
}

.summary {
  border: 1px grey dashed;
}
</style>
